import React from 'react';
import { styled } from '@linaria/react';
import useTranslation from 'next-translate/useTranslation';
import Button from '../../../components/Button';
import DangerButton from '../../../components/Button/DangerButton';
import { Text, Stack, usePopoverOpen } from '@spaceshipapp/cambridge';

interface Props {
  onRemove(): void;
}

const RemoveWarning: React.FC<Props> = ({ onRemove }) => {
  const { t } = useTranslation('common');
  const togglePopover = usePopoverOpen();

  const handleClose = () => {
    togglePopover(false);
  };

  return (
    <Stack>
      <Text>{t('Parcel.modalWarningDescription')}</Text>
      <Wrapper>
        <DangerButton
          onClick={onRemove}
          data-tracking-label={t('commonEn:Parcel.btnConfirmRemove')}
        >
          {t('Parcel.btnConfirmRemove')}
        </DangerButton>
        <Button onClick={handleClose} data-tracking-label={t('commonEn:Parcel.btnConfirmRemove')}>
          {t('Parcel.btnAbortRemove')}
        </Button>
      </Wrapper>
    </Stack>
  );
};

const Wrapper = styled.div`
  display: flex;
  width: 100%;

  > * {
    flex-grow: 1;
    flex-basis: 0;
  }

  > *:not(:first-child) {
    margin-left: 1rem;
  }
`;

export default RemoveWarning;
